"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interpretMetadata = exports.interpretedMetadataPropType = exports.contentfulMetadataPropType = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _util = require("../components/contentful-views/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * The Model for a contentful Page Metadata.
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/page/fields
 */
var contentfulMetadataPropType = {
  fields: _propTypes["default"].shape({
    pageTitle: _propTypes["default"].string,
    shareTitle: _propTypes["default"].string,
    description: _propTypes["default"].string,
    primaryImage: _propTypes["default"].object,
    openGraphType: _propTypes["default"].string,
    twitterCard: _propTypes["default"].string,
    twitterSite: _propTypes["default"].string,
    additionalMetadata: _propTypes["default"].array,
    jsonLd: _propTypes["default"].object
  })
};
/**
 * Glowforge-internal representation of Page Metadata. This may be obtained by
 * passing a `contentfulMetadataPropType` shape into `interpretMetadataFields`.
 */

exports.contentfulMetadataPropType = contentfulMetadataPropType;
var interpretedMetadataPropType = {
  pageTitle: _propTypes["default"].string,
  shareTitle: _propTypes["default"].string,
  description: _propTypes["default"].string,
  primaryImage: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    width: _propTypes["default"].number,
    height: _propTypes["default"].number
  }),
  openGraphType: _propTypes["default"].string,
  twitterCard: _propTypes["default"].string,
  twitterSite: _propTypes["default"].string,
  additionalMetadata: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    property: _propTypes["default"].string,
    content: _propTypes["default"].string,
    httpEquiv: _propTypes["default"].string
  })),
  pageTitleText: _propTypes["default"].string,
  // Deprecated metadata from parent Page object
  metaDescription: _propTypes["default"].string,
  // Deprecated metadata from parent Page object
  jsonLd: _propTypes["default"].object
};
/**
 * Helpers for retrieving content from an object that adheres to the 'pageMetadataPropType' model.
 */

exports.interpretedMetadataPropType = interpretedMetadataPropType;

var ensureProtocol = function ensureProtocol(url) {
  return url && url.match(/^\/\/\w/) ? "https:".concat(url) : url;
};

var getImageUrl = function getImageUrl() {
  var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ensureProtocol(_lodash["default"].get(image, ['fields', 'file', 'url']));
};

var getImageWidth = function getImageWidth() {
  var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash["default"].get(image, ['fields', 'file', 'details', 'image', 'width']);
};

var getImageHeight = function getImageHeight() {
  var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash["default"].get(image, ['fields', 'file', 'details', 'image', 'height']);
};

var getAdditionalMetadata = function getAdditionalMetadata() {
  var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash["default"].map(metadata.additionalMetadata, function (rawMetadata) {
    return _lodash["default"].get(rawMetadata, 'fields');
  });
};

var interpretImage = function interpretImage(contentfulImage) {
  return _lodash["default"].pickBy({
    url: getImageUrl(contentfulImage),
    width: getImageWidth(contentfulImage),
    height: getImageHeight(contentfulImage)
  }, function (value) {
    return !!value;
  });
};
/**
 * Interprets Page Metadata model from Contentful into a more usable internal
 * representation (modeled as `interpretedMetadataPropType`.
 *
 * @param contentfulMetadataFields - a contentfulMetadataPropType shape
 * @returns {interpretedMetadataPropType shape}
 */


var interpretMetadata = function interpretMetadata() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? {} : _ref$fields;

  var macros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _lodash["default"].pickBy({
    pageTitle: (0, _util.stringSubstitution)(fields.pageTitle, macros),
    shareTitle: (0, _util.stringSubstitution)(fields.shareTitle, macros),
    description: (0, _util.stringSubstitution)(fields.description, macros),
    primaryImage: interpretImage(fields.primaryImage),
    twitterCard: fields.twitterCard,
    twitterSite: fields.twitterSite,
    additionalMetadata: getAdditionalMetadata(fields),
    jsonLd: fields.jsonLd
  }, function (value) {
    return !!value;
  });
};

exports.interpretMetadata = interpretMetadata;